import useReveal from "@/hooks/useReveal";

export default function FounderStory({ heading, paragraphs } = {}) {
  useReveal();

  const defaultHeading = (
    <>
      <span className="text-ink">Binoye Jos, Esq.</span> built this firm{" "}
      <span className="italic">because no parent</span> should walk this alone.
    </>
  );

  const defaultParagraphs = [
    "Binoye Jos hired two prominent law firms and spent $400,000 fighting for custody of his son. Both firms told him he'd never get equal custody. So he fired them, represented himself — and won equal custody. Then he went to law school.",
    "For most attorneys, this work is a job. Binoye left corporate America to be a father. Jos Family Law exists so the next parent has a fighter who has already walked the road.",
  ];

  const paras = paragraphs || defaultParagraphs;

  return (
    <section
      data-testid="founder-section"
      className="relative bg-paper py-24 md:py-36"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Left — Founder portrait */}
          <div className="lg:col-span-6 reveal">
            <div
              data-testid="founder-video-placeholder"
              className="relative aspect-[4/5] w-full max-w-[520px] mx-auto lg:mx-0 overflow-hidden bg-ink"
            >
              <img
                src="/brand/binoye-jos.jpg"
                alt="Binoye Jos — Founder of Jos Family Law."
                className="w-full h-full object-cover object-center select-none"
                draggable={false}
                loading="lazy"
              />
            </div>
          </div>

          {/* Right — story copy */}
          <div className="lg:col-span-6 reveal">
            <h2 className="font-display text-[40px] md:text-[52px] leading-[1.04] tracking-tight text-ink">
              {heading || defaultHeading}
            </h2>
            {paras.map((p, idx) => (
              <p
                key={idx}
                className={
                  (idx === 0 ? "mt-6" : "mt-4") +
                  " text-[17px] leading-[1.75] text-gray-800 max-w-[52ch]"
                }
              >
                {p}
              </p>
            ))}

            <a
              href="#consultation"
              data-testid="founder-cta"
              className="mt-10 group inline-flex items-center justify-center bg-teal text-ink hover:bg-ink hover:text-paper transition-colors duration-300 px-10 py-5 min-w-[320px]"
            >
              <span className="font-mono text-[12px] md:text-[13px] tracking-[0.24em] uppercase font-semibold">
                Schedule Your Confidential Consultation
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
